<template>
  <div class="club-wrapper">
    <div v-if="chiefsObject">
      <draggable class="is-multiline columns chiefs" v-model="chiefsObject">
        <CheifItem v-for="chief in chiefsObject" :key="chief.id" :chief="chief" class="column is-one-third"/>
      </draggable>
      <div class="centered add-document">
        <span class="button-wrapper link" @click="handleAddChief()">
          <a class="button is-info">+</a> Добавить сотрудника
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import draggable from 'vuedraggable'
import CheifItem from 'components/About/DepartmentChief'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Chiefs',
  data () {
    return {
      departmentName: '',
      editableDepartment: null,
      updateTimer: 0,
      departmentAdditionVisible: false
    }
  },
  computed: {
    ...mapState(['chiefs']),
    chiefsObject: {
      get () {
        return deepcopy(this.chiefs)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateChiefsOrder(val)
      }
    }
  },
  created () {
    this.getChiefs()
  },
  methods: {
    ...mapActions(['getChiefs', 'addChief', 'updateChiefsOrder']),
    handleAddChief () {
      this.addChief({
        id: uuidv4(),
        photo: ''
      })
    }
  },
  components: { draggable, CheifItem }
}
</script>

<style scoped>
@import "../../global.css";
.chiefs {
  max-width: 1000px;
  margin: 40px auto;
}
.delete-departament {
  max-width: 200px;
  margin: 13px auto 20px;
  background: red;
  text-align: center;
  color: white;
  cursor: pointer;
  display: block;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// Departments.vue?c4a02b12